<template>
    <div @click="onClose()" class="contacts-filter">
        <form @click.stop>
            <div class="content">
                <fieldset class="control-group max-size">
                    <legend>{{Language.say('contacts.list.filter_by')}}</legend>

                    <ul class="control radio-buttons-group">
                        <li>
                            <input type="radio" name="filterBy" id="filter_attach" :checked="!filter" tabindex="-1">
                            <label @click="onSetFilter('all')" for="attach" tabindex="0">{{Language.say('contacts.list.filter_all')}}</label>
                        </li>
                        <li>
                            <input type="radio" name="filterBy" id="flagged" :checked="filter === 'persons'" tabindex="-1">
                            <label @click="onSetFilter('persons')" for="flagged" tabindex="0">{{Language.say('contacts.list.filter_persons')}}</label>
                        </li>
                        <li>
                            <input type="radio" name="filterBy" id="unread" :checked="filter === 'groups'" tabindex="-1">
                            <label @click="onSetFilter('groups')" for="unread" tabindex="0">{{Language.say('contacts.list.filter_groups')}}</label>
                        </li>
                    </ul>
                </fieldset>
            </div>
        </form>
    </div>
</template>

<script setup>
  import { defineEmits } from "vue";
  import { useRoute }    from "vue-router";
  import Language        from '@/js/Shared/Language/Language.js';

  const route  = useRoute();
  const filter = route.query.filter || null;

  const emit = defineEmits([
    'filterClose',
    'filterSet',
    'filterClear',
  ]);

  const onClose = () => {
    emit('filterClose');
  }

  const onSetFilter = (filter) => {
    if (filter === 'all') {
      clearFilter();
      return;
    }

    setFilter(filter);
  }

  const setFilter = (filter) => {
    emit('filterSet', filter);
  }

  const clearFilter = () => {
    emit('filterClear');
  }
</script>
